import {gql} from 'apollo-boost';

export const GET_VDOLIVESETTOPIC = gql`
  query getVdoLiveSetTopic($id : ID!){
    getVdoLiveSetTopic (
      id: $id
    ) {
      id no nameLocal nameEng vdoLength vdoStreamPath
      vdoLiveSet {
        id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      }
    }
  }
`;

export const GET_VDOLIVESETTOPICS_BY_FILTER = gql`

  query getVdoLiveSetTopicsByFilter($vdoLiveSetFilterInput: VdoLiveSetTopicFilterInput){
    getVdoLiveSetTopicsByFilter (
      vdoLiveSetTopicFilterInput:$vdoLiveSetFilterInput
    ){
      id no nameLocal nameEng vdoLength vdoStreamPath
      vdoLiveSet {
        id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      }
    }
  }
`;

export const GET_VDOLIVESETTOPICS = gql`
  query getVdoLiveSetTopics {
    getVdoLiveSetTopics {
      id no nameLocal nameEng vdoLength vdoStreamPath
      vdoLiveSet {
        id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      }
    }
  }
`;

export const ADD_VDOLIVESETTOPIC = gql`
  mutation addVdoLiveSetTopic(
    $vdoLiveSetId: ID!
    $vdoLiveSetTopicInput: VdoLiveSetTopicInput!
  ) {
    addVdoLiveSetTopic(
      vdoLiveSetId: $vdoLiveSetId
      vdoLiveSetTopicInput: $vdoLiveSetTopicInput
    ) {
      id no nameLocal nameEng vdoLength vdoStreamPath
      vdoLiveSet {
        id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      }
    }
  }
`;

export const UPDATE_VDOLIVESETTOPIC = gql`
  mutation updateVdoLiveSetTopic(
    $id: ID!,
    $vdoLiveSetTopicInput: VdoLiveSetTopicInput!
  ) {
    updateVdoLiveSetTopic(
      id: $id
      vdoLiveSetTopicInput: $vdoLiveSetTopicInput
    ) {
      id no nameLocal nameEng vdoLength vdoStreamPath
      vdoLiveSet {
        id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      }
    }
  }
`;

export const DELETE_VDOLIVESETTOPIC = gql`
  mutation deleteVdoLiveSetTopic($id: ID!) {
    deleteVdoLiveSetTopic(
      id: $id
    ) {
      id no nameLocal nameEng vdoLength vdoStreamPath
      vdoLiveSet {
        id sectionNo code descriptionLocal descriptionEng totalVdoLength remark
      }
    }
  }
`;

